// layoutBreakpoints.js

/**
 * Shared viewport breakpoints for shell + chrome.
 *
 * Keep these in sync with useIsMobile defaults and useNodeSidebarRail.
 */

/** Phone layout: drawer nav, bottom-sheet modals, mobile chrome. */
export const MOBILE_MAX_WIDTH_PX = 640;

/**
 * At/below this width the desktop shell stays on the icon rail and Peek
 * overlays instead of docking. Covers iPad portrait and landscape so the
 * full sidebar does not suddenly steal ~250px at 1024px.
 */
export const TABLET_SHELL_MAX_WIDTH_PX = 1199;

/** Peek docks as a flex sibling only above the tablet shell band. */
export const PEEK_DOCK_MIN_WIDTH_PX = TABLET_SHELL_MAX_WIDTH_PX + 1;

/**
 * Mid-width band where dense split panes (Activity rail, settings side nav)
 * should collapse even though the viewport is still “desktop” for mobile hooks.
 */
export const COMPACT_SPLIT_MAX_WIDTH_PX = 960;
